import { render, staticRenderFns } from "./SportHeader.vue?vue&type=template&id=240dd0b8"
import script from "./SportHeader.vue?vue&type=script&lang=js"
export * from "./SportHeader.vue?vue&type=script&lang=js"
import style0 from "./SportHeader.vue?vue&type=style&index=0&id=240dd0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports